import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ICampaign, IDevice, IUser } from '../interfaces';
import {
    addCampaignToArray,
    dateFromWeekNumber,
    filterCampaignsByMonth,
    flattenCampaigns,
    generateCampaignObjects,
    groupCampaigns,
    removeCampaignFromArray,
    updateCampaignFromArray
} from '../utils';
import { ENDPOINT, IS_TVOS, setToken, TOKEN } from '../utils/constants';
import Calendar from './Calendar';
import { Login } from './Login';
import { NewCampaign } from './NewCampaign';
import Week from './Week';
import WeekView from './WeeksView';
import jwt from 'jsonwebtoken';
import { PanelView } from './Panel';
import Revenue from './Revenue';

interface IState {
    campaigns: ICampaign[];
    devices: IDevice[];
    weekSelected: number;
    date: Date;
    flattenCampaigns: boolean;
    pageSelected: 'WEEKS' | 'MONTHS' | 'NEW_CAMP' | 'PANEL' | 'REVENUE';
    showNotSigned: boolean;
    campaignSelected: null | ICampaign;
    users: IUser[];
    variables: any[];
    lastUpdate: Date;
}

const Manager = (props: { user: IUser; logout: () => void }) => {
    const [state, setState] = useState<IState>({
        campaigns: [],
        devices: [],
        weekSelected: -1,
        pageSelected: IS_TVOS ? 'PANEL' : 'WEEKS',
        showNotSigned: true,
        date: new Date(),
        flattenCampaigns: true,
        campaignSelected: null,
        users: [],
        variables: [],
        lastUpdate: new Date()
    });

    useEffect(() => {
        let agentId = 1;

        if (window.location.host === 'planning-sport.doohyoulike.com') agentId = 8;
        else if (window.location.host === 'planning-campus.doohyoulike.com') agentId = 10;

        fetch(`${ENDPOINT}/${agentId}`, {
            headers: {
                'x-planning-token': IS_TVOS ? 'tv' : TOKEN
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    return res.json();
                } else if (res.status === 500) {
                    props.logout();
                    throw new Error('Not loged in');
                }
            })
            .then((res) =>
                setState((prevState) => ({
                    ...prevState,
                    campaigns: generateCampaignObjects(res.campaigns, res.screens),
                    devices: res.screens.filter(({ ShopId }: { ShopId: number }) => ShopId !== 2),
                    users: res.users,
                    variables: res.variables,
                    lastUpdate: new Date()
                }))
            )
            .catch((err) => console.error(err));
    }, [props]);

    if (state.campaigns.length === 0 && state.devices.length === 0) {
        return <div>Loading...</div>;
    }

    const onRequestUpdate = () => {
        let agentId = 1;

        if (window.location.host === 'planning-sport.doohyoulike.com') agentId = 8;
        else if (window.location.host === 'planning-campus.doohyoulike.com') agentId = 10;

        fetch(`${ENDPOINT}/${agentId}`, {
            headers: {
                'x-planning-token': IS_TVOS ? 'tv' : TOKEN
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    return res.json();
                } else if (res.status === 500) {
                    props.logout();
                    throw new Error('Not loged in');
                }
            })
            .then((res) =>
                setState((prevState) => ({
                    ...prevState,
                    campaigns: generateCampaignObjects(res.campaigns, res.screens),
                    devices: res.screens.filter(({ ShopId }: { ShopId: number }) => ShopId !== 2),
                    users: res.users,
                    variables: res.variables,
                    lastUpdate: new Date()
                }))
            )
            .catch((err) => console.error(err));
    };

    if (state.pageSelected === 'WEEKS') {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="menu">
                        <h3>
                            <button className="btn" onClick={props.logout}>
                                Logout
                            </button>
                            Planning DoohYouLike ({props.user.first_name} {props.user.last_name})
                            <div className="color-badge" style={{ backgroundColor: props.user.color }}></div>
                        </h3>
                        <div className="calendarControls">
                            <div className="mr-10">
                                <label>Afficher les brouillons</label>
                                <input
                                    checked={state.showNotSigned}
                                    value={state.showNotSigned.toString()}
                                    onChange={(e) => setState({ ...state, showNotSigned: e.target.checked })}
                                    type="checkbox"
                                />
                            </div>
                            <select
                                className="view"
                                value={state.pageSelected}
                                onChange={(e) =>
                                    setState({
                                        ...state,
                                        pageSelected: e.target.value as 'WEEKS' | 'MONTHS' | 'PANEL' | 'REVENUE'
                                    })
                                }
                            >
                                <option value="WEEKS">Vue semaines</option>
                                <option value="MONTHS">Vue calendrier</option>
                                <option value="PANEL">Vue panel</option>
                                <option value="REVENUE">Revenus</option>
                            </select>
                            <button
                                className="btn ml-10"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setFullYear(d.getFullYear() - 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Prev
                            </button>
                            <span>{state.date.getFullYear()}</span>
                            <button
                                className="btn"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setFullYear(d.getFullYear() + 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Next
                            </button>
                            <button
                                className="btn"
                                onClick={() => setState((prevState) => ({ ...prevState, pageSelected: 'NEW_CAMP' }))}
                            >
                                <span className="material-icons">add</span>
                            </button>
                        </div>
                    </div>
                    <WeekView
                        campaigns={state.campaigns.filter((c) => {
                            if (state.showNotSigned) {
                                return true;
                            }

                            return c.state === 'passed';
                        })}
                        onCampaignSelect={(c) =>
                            setState((prevState) => ({
                                ...prevState,
                                campaignSelected: c,
                                pageSelected: 'NEW_CAMP'
                            }))
                        }
                        devices={state.devices}
                        date={state.date}
                        users={state.users}
                        user={props.user}
                    />
                </div>
            </React.Fragment>
        );
    } else if (state.pageSelected === 'PANEL') {
        return (
            <PanelView
                campaigns={state.campaigns.filter((c) => {
                    if (state.showNotSigned) {
                        return true;
                    }

                    return c.state === 'passed';
                })}
                onChangeYear={(plus: boolean) => {
                    if (plus) {
                        const d = new Date(state.date);
                        d.setFullYear(d.getFullYear() + 1);
                        setState({
                            ...state,
                            date: d
                        });
                    } else {
                        const d = new Date(state.date);
                        d.setFullYear(d.getFullYear() - 1);
                        setState({
                            ...state,
                            date: d
                        });
                    }
                }}
                onRequestUpdate={onRequestUpdate}
                onSelectWeek={(weekNumber) =>
                    setState((prevState) => ({ ...prevState, weekSelected: weekNumber, pageSelected: 'MONTHS' }))
                }
                devices={state.devices}
                date={state.date}
                users={state.users}
                variables={state.variables}
                lastUpdate={state.lastUpdate}
            />
        );
    } else if (state.pageSelected === 'NEW_CAMP') {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="menu">
                        <h3>Planning DoohYouLike - Nouvelle campagne</h3>
                        <div className="calendarControls">
                            <button
                                className="btn"
                                onClick={() =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        pageSelected: 'WEEKS',
                                        campaignSelected: null
                                    }))
                                }
                            >
                                <span className="material-icons">close</span>
                            </button>
                        </div>
                    </div>
                    <NewCampaign
                        campaigns={state.campaigns}
                        availableDevices={state.devices}
                        baseCampaign={state.campaignSelected}
                        onAddCampaign={(c) =>
                            setState((prevState) => ({
                                ...prevState,
                                pageSelected: 'WEEKS',
                                campaignSelected: null,
                                campaigns: addCampaignToArray(prevState.campaigns, c)
                            }))
                        }
                        onDeleteCampaign={(c) =>
                            setState((prevState) => ({
                                ...prevState,
                                pageSelected: 'WEEKS',
                                campaignSelected: null,
                                campaigns: removeCampaignFromArray(prevState.campaigns, c)
                            }))
                        }
                        onUpdateCampaign={(c) =>
                            setState((prevState) => ({
                                ...prevState,
                                pageSelected: 'WEEKS',
                                campaignSelected: null,
                                campaigns: updateCampaignFromArray(prevState.campaigns, c)
                            }))
                        }
                        onUpdateCampaignLocal={(c) =>
                            setState((prevState) => ({
                                ...prevState,
                                campaigns: updateCampaignFromArray(prevState.campaigns, c)
                            }))
                        }
                        user={props.user}
                    />
                </div>
            </React.Fragment>
        );
    } else if (state.pageSelected === 'REVENUE') {
        let objective = 0;

        for (const v of state.variables) {
            if (v.goal) objective = v.goal;
        }

        return (
            <React.Fragment>
                <div className="container">
                    <div className="menu">
                        <h3>
                            <button className="btn" onClick={props.logout}>
                                Logout
                            </button>
                            Revenus
                            <div className="color-badge" style={{ backgroundColor: props.user.color }}></div>
                            <button className="btn ml-10" onClick={onRequestUpdate}>
                                Refresh
                            </button>
                        </h3>
                        <div>
                            <button
                                className="btn ml-10"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setFullYear(d.getFullYear() - 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Prev
                            </button>
                            <span>{state.date.getFullYear()}</span>
                            <button
                                className="btn ml-10"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setFullYear(d.getFullYear() + 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                    <Revenue
                        campaigns={state.campaigns}
                        devices={state.devices}
                        date={state.date}
                        users={state.users}
                        user={props.user}
                        objective={objective}
                    />
                </div>
            </React.Fragment>
        );
    }

    if (state.weekSelected === -1) {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="menu">
                        <h3>Planning DoohYouLike</h3>
                        <div className="calendarControls">
                            <select
                                className="view"
                                value={state.pageSelected}
                                onChange={(e) =>
                                    setState({ ...state, pageSelected: e.target.value as 'WEEKS' | 'MONTHS' | 'PANEL' })
                                }
                            >
                                <option value="WEEKS">Vue semaines</option>
                                <option value="MONTHS">Vue calendrier</option>
                                <option value="PANEL">Vue panel</option>
                            </select>
                            <button
                                className="btn"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setMonth(d.getMonth() - 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Prev
                            </button>
                            <select
                                className=""
                                onChange={(e) => {
                                    const d = new Date(state.date);
                                    d.setMonth(parseInt(e.target.value));

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                                value={state.date.getMonth()}
                            >
                                <option value="0">jan.</option>
                                <option value="1">fév.</option>
                                <option value="2">mar.</option>
                                <option value="3">avr.</option>
                                <option value="4">mai</option>
                                <option value="5">jun.</option>
                                <option value="6">jul.</option>
                                <option value="7">aou.</option>
                                <option value="8">sep.</option>
                                <option value="9">oct.</option>
                                <option value="10">nov.</option>
                                <option value="11">déc.</option>
                            </select>
                            <span>{state.date.getFullYear()}</span>
                            <button
                                className="btn"
                                onClick={() => {
                                    const d = new Date(state.date);
                                    d.setMonth(d.getMonth() + 1);

                                    setState({
                                        ...state,
                                        date: d
                                    });
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                    <Calendar
                        date={state.date}
                        onWeekSelect={(w) =>
                            setState({
                                ...state,
                                weekSelected: w
                            })
                        }
                        campaigns={flattenCampaigns(
                            groupCampaigns(filterCampaignsByMonth(state.campaigns, state.date)),
                            state.flattenCampaigns
                        )}
                        maxDevices={state.devices.length}
                    />
                </div>
            </React.Fragment>
        );
    }

    const weekStart = dateFromWeekNumber(state.weekSelected, state.date);

    return (
        <React.Fragment>
            <div className="container weekDetails">
                <div className="flex flex-space-between">
                    <h3>
                        <button
                            className="btn"
                            onClick={() =>
                                setState({
                                    ...state,
                                    pageSelected: IS_TVOS ? 'PANEL' : 'MONTHS',
                                    weekSelected: -1
                                })
                            }
                        >
                            Retour
                        </button>{' '}
                        Semaine {state.weekSelected} ({moment(weekStart).format('DD/MM/yyyy')} -{' '}
                        {moment(weekStart).add(6, 'day').format('DD/MM/yyyy')})
                    </h3>
                    <div className="flex flex-center flex-colomn">
                        <button
                            className="btn"
                            onClick={() =>
                                setState({
                                    ...state,
                                    weekSelected: state.weekSelected - 1
                                })
                            }
                        >
                            Précédent
                        </button>
                        <button
                            className="btn"
                            onClick={() =>
                                setState({
                                    ...state,
                                    weekSelected: state.weekSelected + 1
                                })
                            }
                        >
                            Suivant
                        </button>
                    </div>
                </div>
                <Week
                    campaigns={state.campaigns.filter((c) => {
                        if (state.showNotSigned) {
                            return true;
                        }

                        return c.state === 'passed';
                    })}
                    onReturnToPanel={() =>
                        setState({
                            ...state,
                            weekSelected: -1,
                            pageSelected: 'PANEL'
                        })
                    }
                    onNextWeek={() => {
                        setState({
                            ...state,
                            weekSelected: state.weekSelected + 1
                        });
                    }}
                    onPrevWeek={() => {
                        setState({
                            ...state,
                            weekSelected: state.weekSelected - 1
                        });
                    }}
                    devices={state.devices}
                    start={weekStart}
                />
            </div>
        </React.Fragment>
    );
};

const Entry = () => {
    const [state, setState] = useState<{
        isLoggedIn: boolean;
        user: null | IUser;
        loading: boolean;
    }>({
        isLoggedIn: false,
        user: null,
        loading: true
    });

    useEffect(() => {
        const tok = localStorage.getItem('user_planning');
        if (tok) {
            setToken(tok);

            const decoded = jwt.decode(tok);

            if (decoded === null) {
                return;
            }

            setState((prevState) => ({ ...prevState, isLoggedIn: true, loading: false, user: decoded as IUser }));

            return;
        }

        setState((prevState) => ({ ...prevState, loading: false }));
    }, []);

    if (state.loading) {
        return null;
    }

    if (!IS_TVOS && (!state.isLoggedIn || !state.user)) {
        return <Login setUser={(user) => setState({ ...state, user, isLoggedIn: true, loading: false })} />;
    }

    return (
        <Manager
            user={state.user as IUser}
            logout={() => {
                localStorage.removeItem('user_planning');
                setState({
                    ...state,
                    isLoggedIn: false,
                    user: null,
                    loading: false
                });
            }}
        />
    );
};

export default Entry;
